import { Component, OnInit, Input } from "@angular/core";
import { CommonService } from "../service/common.service";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "condition-selecter-modal-app",
  templateUrl: "./condition-selecter-modal.component.html",
})
export class ConditionSelecterModalComponent {
  @Input() inputContentList;
  @Input() inputContentIds;
  contentList: any = [];
  contentIds:any;
  chackedContent: any = [];
  chackedContentIds:string = null;
  chackedContentNames:string = null;
  constructor(public activeModal: NgbActiveModal) {}

  ret: any = {
    status: "",
    template_name: "",
  };

  ngOnInit(): void {
    this.contentList = this.inputContentList;
    this.contentIds = this.inputContentIds;
    this.moldingData();
  }
  moldingData(): void {
    var ids = [];
    if (this.contentIds != null && this.contentIds != undefined && this.contentIds != "") {
      ids = this.contentIds.split(",");
    }
    for (let i = 0; this.contentList.length > i; i++) {
      this.contentList[i]["enabled"] = false;
      for (let c = 0; ids.length > c; c++) {
        if (this.contentList[i]["conditions_s_value"] == ids[c]) {
          this.contentList[i]["enabled"] = true;
        }
      }
    }
  }
  checkedData():void{
    var ids = [];
    var names = [];
    this.chackedContent = this.contentList.filter((item)=>item.enabled === true);
    for (let i = 0; this.chackedContent.length > i; i++) {
      ids[i] = this.chackedContent[i]["content_id"];
      names[i] = this.chackedContent[i]["content_code"]+"："+this.chackedContent[i]["content_nm"];
    }
    this.chackedContentIds = ids.join(',');
    this.chackedContentNames = names.join(', ');
  }
  modalCloseOK() {
    this.checkedData();
    this.ret.status = "OK";
    this.ret.chackedContent = this.chackedContent;
    this.ret.chackedContentIds = this.chackedContentIds;
    this.ret.chackedContentNames = this.chackedContentNames;
    this.activeModal.close(this.ret);
  }
  modalCloseCancel() {
    this.ret.status = "Cancel";
    this.activeModal.close(this.ret);
  }
}



// WEBPACK FOOTER //
// ./src/app/a2125-yconditions-group-s/condition-selecter-modal.component.ts